var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRescaleGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.rescaleGrid{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "rescaleGrid",
    d: "M9.74,8.87V7.32l-4.21,4.21C5.38,11.68,5.19,11.75,5,11.75s-0.38-0.07-0.53-0.22c-0.29-0.29-0.29-0.77,0-1.06 l4.21-4.21H7.13c-0.41,0-0.75-0.34-0.75-0.75c0-0.41,0.34-0.75,0.75-0.75h3.36c0.41,0,0.75,0.34,0.75,0.75v3.36 c0,0.41-0.34,0.75-0.75,0.75C10.08,9.62,9.74,9.28,9.74,8.87z M14.25,13.5H2.5V1.76c0-0.41-0.34-0.75-0.75-0.75S1,1.34,1,1.76v12.5 C1,14.67,1.33,15,1.75,15h12.5c0.41,0,0.75-0.34,0.75-0.75S14.67,13.5,14.25,13.5z M4.83,2.51h3.33c0.41,0,0.75-0.34,0.75-0.75 c0-0.41-0.33-0.75-0.74-0.75H4.83c-0.41,0-0.75,0.34-0.75,0.75C4.08,2.17,4.42,2.51,4.83,2.51z M14.25,1.01h-3 c-0.41,0-0.75,0.34-0.75,0.75c0,0.41,0.34,0.75,0.75,0.75h2.25v2.25c0,0.41,0.34,0.75,0.75,0.75S15,5.17,15,4.76v-3 C15,1.34,14.67,1.01,14.25,1.01z M14.25,7.09c-0.41,0-0.75,0.34-0.75,0.75v3.33c0,0.41,0.34,0.75,0.75,0.75S15,11.59,15,11.17V7.84 C15,7.43,14.67,7.09,14.25,7.09z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRescaleGrid);
export default __webpack_public_path__ + "static/media/icon_rescale-grid.92a40516839429b492288cdb6e88704c.svg";
export { ForwardRef as ReactComponent };